import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ colors, font }) => ({
  text: {
    color: colors.foregroundDefault,
    variants: {
      preset: {
        heading1: {
          fontFamily: font.families.heading1,
          fontSize: font.sizes.heading1,
          lineHeight: font.lineHeights.heading1,
          fontWeight: "800",
        },
        heading2: {
          fontFamily: font.families.heading2,
          fontSize: font.sizes.heading2,
          lineHeight: font.lineHeights.heading2,
          fontWeight: "800",
        },
        heading3: {
          fontFamily: font.families.heading3,
          fontSize: font.sizes.heading3,
          lineHeight: font.lineHeights.heading3,
          fontWeight: "800",
        },
        heading4: {
          fontFamily: font.families.heading4,
          fontSize: font.sizes.heading4,
          lineHeight: font.lineHeights.heading4,
          fontWeight: "600",
        },
        heading5: {
          fontFamily: font.families.heading5,
          fontSize: font.sizes.heading5,
          lineHeight: font.lineHeights.heading5,
          fontWeight: "600",
        },
        heading6: {
          fontFamily: font.families.heading6,
          fontSize: font.sizes.heading6,
          lineHeight: font.lineHeights.heading6,
          fontWeight: "600",
        },
        heading7: {
          fontFamily: font.families.heading7,
          fontSize: font.sizes.heading7,
          lineHeight: font.lineHeights.heading7,
          fontWeight: "600",
        },
        body: {
          fontFamily: font.families.body,
          fontSize: font.sizes.body,
          lineHeight: font.lineHeights.body,
          fontWeight: "400",
          _web: {
            textWrap: "balance",
          },
        },
        span: {
          fontFamily: font.families.body,
          fontSize: font.sizes.body,
          lineHeight: font.lineHeights.body,
          fontWeight: "400",
        },
        tiny: {
          fontFamily: font.families.sub,
          fontSize: font.sizes.sub,
          lineHeight: font.lineHeights.sub,
          fontWeight: "400",
        },
      },
    },
  },
}));

export default stylesheet;
